import { GroupsService } from '@/backend/market/services/GroupsService'
import { UserGroupRepository } from '../../domain/repositories/UserGroupRepository'
import { UserGroupModel } from '../models/UserGroupModel'
import type { UserGroupFilterEntity } from '../../domain/entities/UserGroupFilterEntity'
import { UserGroupFilterModel } from '../models/UserGroupFilterModel'
import { PaginateEntity } from '@/shared/entities/PaginateEntity'
import type { UserGroupEntity } from '../../domain/entities/UserGroupEntity'
import type { UserMiniEntity } from '@/features/user/domain/entities/UserMiniEntity'
import { UserMiniModel } from '@/features/user/data/models/UserMiniModel'

export class UserGroupRepositoryImpl implements UserGroupRepository {
  async getUserGroups(
    filterData: UserGroupFilterEntity
  ): Promise<PaginateEntity<UserGroupEntity[]> | { error: true }> {
    const filterModel = new UserGroupFilterModel(filterData)
    try {
      const response = await GroupsService.getGroupsAdmin(filterModel)
      const userModel = response.items?.map((item) => new UserGroupModel(item))
      const result = new PaginateEntity<UserGroupModel[]>(response, userModel)
      return result
    } catch {
      return { error: true }
    }
  }
  async getUserGroup(id: number): Promise<UserGroupEntity | { error: true }> {
    try {
      const response = await GroupsService.getGroupAdmin({
        id
      })
      const userModel = new UserGroupModel(response)
      return userModel
    } catch {
      return { error: true }
    }
  }
  async getGroupUsers(id: number): Promise<PaginateEntity<UserMiniEntity[]> | { error: true }> {
    try {
      const response = await GroupsService.getGroupUsersAdmin({
        id
      })
      const userModel = response.items?.map((item) => new UserMiniModel(item))
      const result = new PaginateEntity<UserMiniModel[]>(response, userModel)
      return result
    } catch {
      return { error: true }
    }
  }
  async getGroupPhoneNumbers(id: number): Promise<PaginateEntity<string> | { error: true }> {
    try {
      const response = await GroupsService.getGroupUsersAdmin1({
        id
      })
      return response
    } catch {
      return { error: true }
    }
  }
}
